import * as React from 'react';
import styled from 'styled-components';
import { Input } from '../Input';
import { InputLabel } from '../Input/Input';
import { IBLabeledInputProps } from './LabeledInput.types';

const InputErrorText = styled.div`
  position: absolute;
  margin-top: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: ${({ theme }) => theme.colors.alert};
`;

const LabeledInput: React.FC<IBLabeledInputProps> = (
  props: IBLabeledInputProps
) => {
  const {
    label,
    id,
    type,
    onChange,
    className,
    value,
    errorMessage,
    error,
    disabled,
    placeholder,
    testId
  } = props;

  return (
    <div className={`labeled-input ${className ?? ''}`}>
      {label && <InputLabel>{label}</InputLabel>}
      <Input
        id={id}
        disabled={disabled}
        error={error}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        type={type}
        testId={testId}
      />
      {errorMessage && <InputErrorText>{errorMessage}</InputErrorText>}
    </div>
  );
};

export default LabeledInput;
